import SelectSearchContainer from './SelectSearchContainer';

export default SelectSearchContainer;
